import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, dialog, details, grid } from '../../utilities/styles';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, validateURL, releaseFormLockwithBeacon, hideRevealInputs } from '../../utilities/formsUtilities';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
import { eyeSvg, deleteIcon, expandIcon, collapseIcon } from '../../utilities/icons';
import { hideRevealPassword } from '../../utilities/formsUtilities';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInIntegrationsBase } from '../Utilities/AllInIntegrationsBase';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInIntegrationForm extends AllInIntegrationsBase(AllInSessionStorage(AllInOrganisationConsumer(LitElement))) {
    static properties = {
        _isFormLocked: { state: true, type: Boolean },
        _formHasValues: { state: true, type: Boolean },
        _usesActionLinks: { state: true, type: Boolean },
        loading: { state: true, type: Boolean },
        success: { state: true, type: Boolean },
    };
    constructor() {
        super();
    }
    get _form() {
        return this.shadowRoot.querySelector('form');
    }
    async connectedCallback() {
        super.connectedCallback();
        if (this.providerConfig) {
            this.formID = `organisation_integration_${this.currentOrg}`;
        }
        this.uid = `integration-form-${this.organisationData.user.id}`;
        this.renderRoot.querySelector('a')?.focus();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
        releaseFormLock(this.formID, this.uid, this.restUrl, this.nonce);
    }
    async firstUpdated() {
        if (this.formID) {
            this._isFormLocked = await checkFormLock(this.formID, this.uid, this.restUrl, this.nonce);
            addEventListener('visibilitychange', (event) => {
                if (document.visibilityState === 'hidden') {
                    releaseFormLockwithBeacon(this.formID, this.uid, this.restUrl, this.nonce);
                }
            });
        }
    }
    updated(changedProperties) {
        if (this._form) {
            hideRevealInputs(this._form);
        }
    }
    /* <button id="zone" class="btn change_view ${this.view=='zone'?'active':''}" disabled aria-pressed="${this.view=='zone'?'true':'false'}">
        ${msg('Manage zones. Coming soon')}
    </button>  */
    render() {
        let main = '';
        if (this.loading) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            if (this.providerConfig && this._isFormLocked) {
                main = html `\n                    <h3>Integreiddio darparwyr tocynnau</h3>\n                    <div class="bg">\n                        <div class="message notice" aria-live="polite">\n                            <p>Mae aelod arall o\u2019r sefydliad hwn wrthi\u2019n golygu\u2019r ffurflen hon</p>\n                        </div>\n                    </div>\n                `;
            }
            if (this.success) {
                let _hasConfig = Object.keys(this.providerConfig ?? {}).length > 0;
                let memberDisabled = false;
                let memberText = '';
                if (this.providerConfig?.provider == 'TicketsolveJSON' || this.providerConfig?.provider == 'TicketsolveXML') {
                    memberDisabled = true;
                    memberText = `Dydy eich darparwr tocynnau presennol ddim yn gallu integreiddio data aelodau.`;
                }
                else if (this.providerConfig?.provider == 'DMS' || this.providerConfig?.usesActionLinks) {
                    memberDisabled = true;
                    memberText = 'You are using Action Links for your Membership Integration.';
                }
                else {
                    memberText = _hasConfig ? html `<a href="javascript:void(0)" class="card_target" @click=${(e) => this._showPanel('member-configuration')}>Rheoli data aelodau</a>` : html `<p class="disabled_message">Mae angen i chi ffurfweddu eich darparwr tocynnau cyn i chi allu rheoli data aelodau</p>`;
                    memberDisabled = !_hasConfig;
                }
                let eventText = '';
                let eventDisabled = false;
                if (this._hasConfig) {
                    if (this.providerConfig?.provider == 'DMS') {
                        eventDisabled = true;
                        eventText = `Your ticketing provider doesn't support event listing integration.`;
                    }
                    else {
                        eventText = html `<a href="javascript:void(0)" class="card_target" @click=${(e) => this._showPanel('event-configuration')}>Rheoli data rhestr digwyddiadau</a>`;
                    }
                }
                else {
                    eventDisabled = true;
                    eventText = html `<p class="disabled_message">Mae angen i chi ffurfweddu eich darparwr tocynnau cyn i chi allu rheoli data rhestr digwyddiadau</p>`;
                }
                main = html `\n                    <h3>Llwyddiant</h3>\n                    <div class="message notice" aria-live="polite">\n                        <p>Llwyddiant! Rydych chi wedi cysylltu eich darparwr tocynnau.</p>\n                    </div>\n                    <h3>Y camau nesaf</h3>    \n\n                    <div class="grid grid_50">\n                        <div class="bg inner-padding card ${eventDisabled ? 'disabled' : ''}">\n                            <h3>Integreiddio rhestr digwyddiadau</h3>\n                            <p>${unsafeHTML(this.integration_panels?.integrations_event_listing_description_text)}</p>\n                            ${eventText}\n                        </div>\n                        <div class="bg inner-padding card ${memberDisabled ? 'disabled' : ''}">\n                            <h3>Integreiddio aelodau</h3>\n                            <p>${unsafeHTML(this.integration_panels?.integrations_member_description_text)}</p>\n                            ${memberText}\n                        </div>\n                    </div>\n                `;
            }
            else {
                let form_elements = ``;
                if (this.providerConfig?.provider == 'SpektrixV3') {
                    form_elements = html `\n                    <div class="input-group">\n                        <label for="baseUrl">URL Sylfaen Spektrix*</label>\n                        <p class="small">Enghraifft: https://system.spektrix.com/{clientcode}/api/v3 or https://{your.custom.domain}/{clientcode}</p>  \n                        <input type="url" id="baseUrl" name="baseUrl" data-label="URL Sylfaen Spektrix" data-table_label="URL Sylfaen Spektrix" aria-required="true" value="${this.providerConfig?.configuration?.baseUrl}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="host">Lletywr Spektrix*</label>\n                        <p class="small">Enghraifft: system.spektrix.com or {your.custom.domain}. No protocol needed.</p>\n                        <input type="text" id="host" name="host" data-label="Lletywr Spektrix" data-table_label="Lletywr Spektrix" aria-required="true" value="${this.providerConfig?.configuration?.host}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="username">Enw Defnyddiwr Spektrix*</label>\n                        <input type="text" id="username" name="username" data-label="Enw Defnyddiwr Spektrix" data-table_label="Enw Defnyddiwr Spektrix" aria-required="true" value="${this.providerConfig?.configuration?.username}" />\n                    </div>\n                     <div class="input-group">\n                        <label for="apiSecretKey">Allwedd API Spektrix*</label>  \n                        <div class="pword_wrapper">\n                            <input type="password" id="apiSecretKey" name="apiSecretKey" data-label="Allwedd API Spektrix" data-table_label="Allwedd API Spektrix" aria-required="true" value="${this.providerConfig?.configuration?.apiSecretKey}">\n                            <button data-switch="apiSecretKey" aria-label="Dangos Allwedd API" aria-pressed="false" type="button" class="show-password" data-show="Dangos Allwedd API" data-hide="Cuddio allwedd API" @click=${hideRevealPassword}>\n                            ${eyeSvg} Dangos Allwedd API</button>\n                        </div>\n                    </div>\n                    <div class="input-group">\n                        <label for="usesActionLinks">Use Action Links</label>\n                        <input type="checkbox" name="usesActionLinks" id="usesActionLinks" data-label="Use Action Links" data-table_label="Use Action Links" @change=${(e) => { this._handleUsesActionLinksChange(e); }} ?checked=${this._usesActionLinks || this.providerConfig?.usesActionLinks} />\n                    </div>\n                   `;
                }
                else if (this.providerConfig?.provider == 'TicketsolveJSON' || this.providerConfig?.provider == 'TicketsolveXML' || this.providerConfig?.provider == 'Ticketsolve') {
                    let url = '';
                    if (this.providerConfig?.provider == 'TicketsolveJSON')
                        url = this.providerConfig?.configuration?.baseUrl;
                    else
                        url = this.providerConfig?.configuration?.url;
                    form_elements = html `\n                    <div class="input-group">\n                        <label for="feedtype">Math o borthiant Ticketsolve*</label>\n                        ${this.integration_panels?.integrations_ticketsolve_description ? html `<p class="small">${this.integration_panels?.integrations_ticketsolve_description}</p>` : ''}\n                        <select id="feedtype" name="feedtype" data-label="Math o borthiant Ticketsolve" data-table_label="Math o borthiant Ticketsolve" aria-required="true" data-hider="ticketsolve-api-key" data-reveal="TicketsolveJSON">\n                            <option value="TicketsolveXML" ?selected=${this.providerConfig?.provider == 'TicketsolveXML'}>XML</option>\n                            <option value="TicketsolveJSON" ?selected=${this.providerConfig?.provider == 'TicketsolveJSON'}>JSON</option>\n                        </select>\n                    </div>\n                    <div class="input-group hidden ticketsolve-api-key" >\n                        <label for="apikey">Allwedd API Ticketsolve*</label>\n                        <input type="text" id="apikey" name="apikey" data-label="Allwedd API Ticketsolve" data-table_label="Allwedd API Ticketsolve" aria-required="true" value="${this.providerConfig?.configuration?.apiKey}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="url">URL Ticketsolve*</label>\n                        <input type="url" id="url" name="url" data-label="URL Ticketsolve" data-table_label="URL Ticketsolve" aria-required="true" value="${url}" />\n                    </div>\n                     <div class="input-group">\n                        <label for="usesActionLinks">Use Action Links</label>\n                        <input type="checkbox" name="usesActionLinks" id="usesActionLinks" data-label="Use Action Links" data-table_label="Use Action Links" @change=${(e) => { this._handleUsesActionLinksChange(e); }} ?checked=${this._usesActionLinks || this.providerConfig?.usesActionLinks} />\n                    </div>\n                    `;
                }
                else if (this.providerConfig?.provider == 'TessituraV15') {
                    //Add the following inputs: baseURl,username,password,group,location
                    form_elements = html `\n                    <div class="input-group">\n                        <label for="baseUrl">URL Sylfaen Tessitura*</label>\n                        <input type="url" id="baseUrl" name="baseUrl" data-label="URL Sylfaen Tessitura" data-table_label="URL Sylfaen Tessitura" aria-required="true" value="${this.providerConfig?.configuration?.baseUrl}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="username">Enw defnyddiwr Tessitura*</label>\n                        <input type="text" id="username" name="username" data-label="Enw defnyddiwr Tessitura" data-table_label="Enw defnyddiwr Tessitura" aria-required="true" value="${this.providerConfig?.configuration?.username}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="password">Cyfrinair Tessitura*</label>\n                        <div class="pword_wrapper">\n                            <input type="password" id="password" name="password" data-label="Cyfrinair Tessitura" data-table_label="Cyfrinair Tessitura" aria-required="true" value="${this.providerConfig?.configuration?.password}" />\n                            <button data-switch="password" aria-label="Dangos cyfrinair Tessitura" aria-pressed="false" type="button" class="show-password" data-show="Dangos cyfrinair Tessitura" data-hide="Cuddio cyfrinair Tessitura" @click=${hideRevealPassword}>\n                            ${eyeSvg} Dangos cyfrinair Tessitura</button>\n                        </div>\n                    </div>\n                    <div class="input-group">\n                        <label for="group">Gr\u0175p Tessitura*</label>\n                        <input type="text" id="group" name="group" data-label="Gr\u0175p Tessitura" data-table_label="Gr\u0175p Tessitura" aria-required="true" value="${this.providerConfig?.configuration?.group}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="location">Lleoliad Tessitura*</label>\n                        <input type="text" id="location" name="location" data-label="Lleoliad Tessitura" data-table_label="Lleoliad Tessitura" aria-required="true" value="${this.providerConfig?.configuration?.location}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="constituentTypeId">ID Math o Gyfansoddyn Tessitura*</label>\n                        <input type="text" id="constituentTypeId" name="constituentTypeId" data-label="ID Math o Gyfansoddyn Tessitura" data-table_label="ID Math o Gyfansoddyn Tessitura" aria-required="true" value="${this.providerConfig?.configuration?.constituentTypeId}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="originalSourceId">ID Ffynhonnell Wreiddiol Tessitura*</label>\n                        <input type="text" id="originalSourceId" name="originalSourceId" data-label="ID Ffynhonnell Wreiddiol Tessitura" data-table_label="ID Ffynhonnell Wreiddiol Tessitura" aria-required="true" value="${this.providerConfig?.configuration?.originalSourceId}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="businessUnitId">ID Uned Fusnes*</label>\n                        <input type="text" id="businessUnitId" name="businessUnitId" data-label="ID Uned Fusnes" data-table_label="ID Uned Fusnes" aria-required="true" value="${this.providerConfig?.configuration?.businessUnitId}" />\n                    </div>\n                    <div class="input-group">\n                        <label for="usesActionLinks">Use Action Links</label>\n                        <input type="checkbox" name="usesActionLinks" id="usesActionLinks" data-label="Use Action Links" data-table_label="Use Action Links" @change=${(e) => { this._handleUsesActionLinksChange(e); }} ?checked=${this._usesActionLinks || this.providerConfig?.usesActionLinks} />\n                    </div>\n                    `;
                }
                let actionLinksFormElements = '';
                if (this._usesActionLinks || this.providerConfig?.usesActionLinks) {
                    actionLinksFormElements = html `\n                        <div class="input-group">\n                            <label for="actionLinksUrl">Action Links URL*</label>\n                            <input type="text" id="actionLinksUrl" name="actionLinksUrl" data-label="Action Links URL" data-table_label="Action Links URL" aria-required="true" value="${this.providerConfig?.actionLinksUrl}" aria-required="true"/>\n                        </div>\n                    `;
                }
                main = html `\n                    <div class="form_container">\n                        ${this._eventsError ? html `<div class="message error"><p>${this._eventsError}</p></div>` : ''}\n                        <p>${unsafeHTML(this.integration_panels?.integrations_event_listing_intro_text)}</p>\n                        <h3>${this.providerConfig ? `Diweddaru eich llwyfan tocynnau` : `Dewis eich llwyfan tocynnau`}</h3>\n                    \n                        <div class="message notice" aria-live="polite">\n                            ${this.message ? html `<p>${this.message}</p>` : ''}\n                        </div>\n                        <form @submit=${this._handleSubmit}>\n                            <div class="message notice" aria-live="polite">\n                            </div>\n                            <div class="bg">\n                                <div class="input-group">\n                                    <label for="provider">${this.providerConfig?.configuration ? `Diweddaru eich llwyfan tocynnau` : `Which platform do you want to connect with?`}*</label>\n                                    <p class="small"><a href="https://allin.zendesk.com">Can't find your ticketing platform? Chat with All In.</a></p>\n                                    <select name="provider" id="provider" data-label="Llwyfan tocynnau" data-table_label="Llwyfan tocynnau" @change=${(e) => { this._handleProviderChange(e); }}>\n                                        <option value="">Dewiswch</option>\n                                        <option value="SpektrixV3" ?selected=${this.providerConfig?.provider == 'SpektrixV3'}>Spektrix</option>\n                                        <option value="Ticketsolve" ?selected=${this.providerConfig?.provider == 'TicketsolveJSON' || this.providerConfig?.provider == 'Ticketsolve' || this.providerConfig?.provider == 'TicketsolveXML'}>Ticketsolve</option>\n                                        <option value="TessituraV15" ?selected=${this.providerConfig?.provider == 'TessituraV15'}>Tessitura</option>\n                                        <option value="DMS" ?selected=${this.providerConfig?.provider == 'DMS'}>Action Links only</option>\n                                    </select>\n                                </div>\n                                <p><a href="https://allin.zendesk.com" target="_blank" rel="noopener noreferrer">Gweld dogfen gymorth ar sut i integreiddio data eich digwyddiad ag I Bawb.</a></p>\n                                <div aria-live="polite">\n                                    ${form_elements}\n                                </div>\n                                \n                                <div aria-live="polite">\n                                    ${actionLinksFormElements}\n                                </div>\n                                <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                                <input type="hidden" name="action" value="add-provider" />\n                                <div class="button-group">\n                                    <button type="submit" ?disabled=${(!this.providerConfig?.provider || this.providerConfig?.provider == 'DMS') && !this.providerConfig?.usesActionLinks}>Cyflwyno</button>\n                                </div>   \n                                <hr>\n                                <a href="javascript:void(0)" @click=${this._hidePanel}>${deleteIcon}Canslo</a>\n                            </div>\n                        </form>\n                    </div>\n                `;
            }
        }
        return html `${main}`;
    }
    _handleProviderChange(e) {
        let provider = e.target.value;
        if (provider == 'DMS') {
            this._usesActionLinks = true;
        }
        this.providerConfig = {
            provider: provider,
            usesActionLinks: this._usesActionLinks || false
        };
    }
    _handleUsesActionLinksChange(e) {
        this._usesActionLinks = e.target.checked;
        if (this.providerConfig) {
            this.providerConfig.usesActionLinks = this._usesActionLinks;
        }
    }
    _handleClick(e) {
        e.preventDefault();
        this.panel = '';
        this.view = '';
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name} Dangosfwrdd` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `Integreiddio` }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/integrations', { panel: '', view: '' });
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'integrations', panel: ``, view: '' });
        this.partial = false;
    }
    async _handleSubmit(e) {
        e.preventDefault();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');
        let valid = validateForm(this._form, formResponse);
        if (!valid) {
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        //formData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (response.ok) {
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                this.providerConfig = response.provider;
                this.success = true;
                this.organisation.integration_config = response.provider;
                this._updateContext({ organisation: this.organisation, providerConfig: this.providerConfig, providerConfigMapping: response.provider?.mapping });
                submitButton.disabled = false;
            }
            else {
                formResponse.innerHTML = response.message;
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        }
        ;
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    _validateURL(e) {
        if (e.target.type !== 'url')
            return;
        validateURL(e.target);
    }
    _checkIfFormHasValues(e) {
        let form = this._form;
        let selects = form.querySelectorAll('select');
        let hasValues = false;
        for (let i = 0; i < selects.length; i++) {
            let select = selects[i];
            if (select.id == 'event_select')
                continue;
            if (select.value) {
                if (select.id.startsWith('location_')) {
                    this._handleLocationChange({ target: select }, select.id.replace('location_', ''));
                }
                hasValues = true;
            }
        }
        ;
        this._formHasValues = hasValues;
    }
    static styles = [
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {

            .button-group button:hover svg, .return:hover svg{
                transform:none;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child:not(.duet-date__cell){
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
                background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
                font-weight: var(--allin-button-font-weight, 600);
                color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            max-height:0;
            overflow:hidden;
            transition:all var(--transition) ease;
            transition-behavior: allow-discrete;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            max-height:700px;
            box-sizing: border-box;
            overflow:visible;
        }

        .provision {
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            border-bottom: 2px solid var(--allin-highlight-color,#472961);
            gap:0.5rem;
        }

        .provision:last-child {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        .add_uploader{
            background-color: var(--allin-button-bg-color, #472961);
            color: #fff;
            margin-bottom: 1.5rem;
        }
        .add_uploader span svg {
            background-color: #fff;
            transform: translate(0px, 3px);
        }

        .add_uploader:hover span svg {
            background-color: transparent;
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-size:clamp(1.25rem, 5cqw, 1.5rem);
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions.no-image summary{
            grid-template-columns: 1fr;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .instances{
            padding:0;
            margin:0;
            list-style:none;
        }

        .instances li:not(:last-child){
            margin-bottom:1rem;
            padding-bottom:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
        }
        
        .instances dl{
            display:grid;
            grid-template-columns: max-content 1fr;
            gap:1rem;
        }
         @media screen and (min-width:700px){
            .instances dl{
                display:grid;
                grid-template-columns: max-content 1fr;
                gap:1rem;
            }
         }

        .instances dl dt{
            font-weight:500;
        }
        
        dd h4{
            margin:0 0 0.5rem 0;
        }

        dd p{
            margin-bottom:1rem;
        }
        p:has(+.provisions){
            grid-column: 1 / -1;
            margin-top:2rem;
            margin-bottom:0;
        }
        .repeater{
            padding:0 2rem;
        }

        .card.disabled{
            background-color:  #e1e1e1;
            pointer-events: none;
            color: #555;
        }

        .disabled_message{
            font-style:italic;
            color:var(--allin-highlight-color,#472961);
        }
        .grid {
            gap: 1.5rem;
        }

        .card a{
            display:block;
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            background-color:var(--allin-highlight-color,#472961);
            color:#fff;
            text-align:center;
            font-weight:700;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            height:fit-content;
            align-self:end;
        }

        .card:hover a{
            background-color:var(--allin-highlight-color-lighter,#5e3e7d);
        }

        @media (min-width: 700px) {
            .show-password {
                top: calc(100% + 0.5rem)!important;
            }
        }
        .form_container{
            margin-top:2rem;
        }
        `
    ];
}
